export default "__VITE_ASSET__DrIVX7IE__"